import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ArrowRight, ShieldCheck, Truck, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-beige overflow-hidden" data-id="element-61">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20 pointer-events-none" data-id="element-62">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-green rounded-full blur-3xl" data-id="element-63"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-brand-gold rounded-full blur-3xl" data-id="element-64"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-28 relative z-10" data-id="element-65">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-66">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col items-start text-left" data-id="element-67">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-cream border border-brand-gold/30 text-brand-gold text-sm font-medium mb-6" data-id="element-68">
              Oser Pro Labs
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-brand-green leading-tight mb-6" data-id="element-69">
              Triple extracto de hongos para tu bienestar diario
            </h1>
            <p className="text-lg sm:text-xl text-brand-brown/80 mb-8 max-w-xl leading-relaxed" data-id="element-70">
              Reishi, Cordyceps y Melena de León en fórmulas naturales pensadas
              para acompañar tu energía, equilibrio y enfoque en la rutina
              diaria.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-71">
              <a href="https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20extractos%20de%20hongos" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-brand-green text-white text-base font-medium rounded-full hover:bg-brand-lightGreen transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 w-full sm:w-auto" data-id="element-72">
                <MessageCircle className="mr-2" size={20} data-id="element-73" />
                Consultar por WhatsApp
              </a>
              <a href="#productos" className="inline-flex items-center justify-center px-8 py-4 bg-white text-brand-green border border-brand-green/20 text-base font-medium rounded-full hover:bg-brand-beige transition-all w-full sm:w-auto" data-id="element-74">
                Ver productos
                <ArrowRight className="ml-2" size={20} data-id="element-75" />
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 sm:gap-6 text-sm text-brand-brown/70" data-id="element-76">
              <div className="flex items-center gap-1.5" data-id="element-77">
                <ShieldCheck size={18} className="text-brand-gold" data-id="element-78" />
                <span data-id="element-79">Extractos de alta concentración</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-80">
                <MessageCircle size={18} className="text-brand-gold" data-id="element-81" />
                <span data-id="element-82">Consulta directa por WhatsApp</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-83">
                <Truck size={18} className="text-brand-gold" data-id="element-84" />
                <span data-id="element-85">Despacho según disponibilidad</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-86">
            <div className="aspect-[4/5] sm:aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/nrT6gMZ5S5nQ9khweXk8fA/hongotodos.jpg" alt="Extractos de Reishi, Cordyceps y Melena de León" className="w-full h-full object-cover" data-id="element-88" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-89"></div>
              <div className="absolute bottom-6 left-6 right-6 flex justify-center gap-3" data-id="element-90">
                <span className="px-3 py-1.5 bg-white/90 backdrop-blur-sm text-brand-green text-xs font-bold rounded-full shadow-sm" data-id="element-91">
                  Reishi
                </span>
                <span className="px-3 py-1.5 bg-white/90 backdrop-blur-sm text-brand-green text-xs font-bold rounded-full shadow-sm" data-id="element-92">
                  Cordyceps
                </span>
                <span className="px-3 py-1.5 bg-white/90 backdrop-blur-sm text-brand-green text-xs font-bold rounded-full shadow-sm" data-id="element-93">
                  Melena de León
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}